import React, { useContext } from "react";

import TRow from "./TRow";

import TableContext from "./TContext";

const TBody = () => {
  const { diagnosis, handleUpdate } = useContext(TableContext);

  return (
    <>
      {diagnosis.map((doc) => (
        <TRow key={doc._id || doc.id} doc={doc} handleUpdate={handleUpdate} />
      ))}
    </>
  );
};

export default TBody;
